import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'
import { mediaQueries } from '../../constants/mediaQueries'

const styles = css({
	fontSize: "20px",
	[mediaQueries.isMobile]: {
		fontSize: '18px',
	},
})

const H1 = ({ children, ...otherProps }) => {
	return <h1 {...propMerge(styles, otherProps)}>{children}</h1>
}

export default H1
